import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';


const ModalActions = {

    open (type, data) {
        AppDispatcher.dispatch({
            type,
            data,
            actionType: ActionTypes.MODAL_OPENED
        });
    },

    close (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.MODAL_CLOSED
        });
    }

};

export default ModalActions;



// WEBPACK FOOTER //
// ./src/actions/ModalActions.js